import { render, staticRenderFns } from "./calls.vue?vue&type=template&id=8f44ba0e&scoped=true&"
import script from "./calls.vue?vue&type=script&lang=js&"
export * from "./calls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f44ba0e",
  null
  
)

export default component.exports